export default __webpack_public_path__ + "static/media/logo.518c9c11.jpg";